import { Navigate } from "react-router-dom";

/** Ancienne URL : même écran que Admin → Avatar video. */
export default function AvatarBuilder() {
  return <Navigate to="/admin?app=avatar" replace />;
}
